export class CustomAttribute {
  id: string;
  label: string;
  key: string;
  deactivated: boolean;
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy: string;
  _version: number;
}
